import { render, staticRenderFns } from "./PunjabIndicators.vue?vue&type=template&id=25497c80&scoped=true&"
import script from "./PunjabIndicators.vue?vue&type=script&lang=js&"
export * from "./PunjabIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25497c80",
  null
  
)

export default component.exports